import {
  forwardRef,
  Ref,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { CFieldType, Email } from "../../../types/RecordInterfaces";
import ComplexRecordDrawer from "./ComplexRecordDrawer";
import ComplexRecordNoDrawer from "./ComplexRecordNoDrawer";

interface Props {
  existingValue: Array<Email>;
  recordID: string;
  type: "Email" | "Phone";
  field: any;
  mode: "rw" | "r";
  tableView: any;
  error: any;
  submitting: any;
  modifyTrigger: any;
  onUpdate: (val: any) => void;
  isDrawer: boolean;
  displayRecord: React.ReactNode | undefined;
}

const emptyValues: [] = [];

const ComplexRecord = (
  {
    error,
    submitting,
    tableView,
    onUpdate,
    existingValue,
    field,
    recordID,
    type,
    modifyTrigger,
    mode,
    isDrawer,
    displayRecord,
  }: Props,
  ref?: Ref<HTMLInputElement>
) => {
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [existingValues, setExistingValues] = useState<CFieldType[]>(
    structuredClone(existingValue)
  );
  const [values, setValues] = useState<CFieldType[]>(
    existingValues || emptyValues
  );

  const inputRef = useRef<HTMLInputElement>(null);

  // Sync the state with existing data
  useEffect(() => {
    const theValues = structuredClone(existingValue);
    setExistingValues(theValues);
    setValues(theValues || emptyValues);
  }, [existingValue]);

  // @ts-ignore
  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus();
    },
  }));

  // Currently using Mantine when this record field is opened inside a Drawer and using Rsuite when opened in non-drawer (Main table)
  // Using Mantine in both causes issues in multisubitems and using Rsuite loses focus on enter
  return true ? (
    <ComplexRecordDrawer
      ref={inputRef}
      open={open}
      mode={mode}
      tableView={tableView}
      isEditing={isEditing}
      setOpen={setOpen}
      values={values}
      existingValues={existingValues}
      onUpdate={onUpdate}
      field={field}
      recordID={recordID}
      setExistingValues={setExistingValues}
      setIsEditing={setIsEditing}
      setValues={setValues}
      modifyTrigger={modifyTrigger}
      submitting={submitting}
      type={type}
    />
  ) : (
    <ComplexRecordNoDrawer
      open={open}
      mode={mode}
      tableView={tableView}
      isEditing={isEditing}
      setOpen={setOpen}
      values={values}
      existingValues={existingValues}
      onUpdate={onUpdate}
      field={field}
      recordID={recordID}
      setExistingValues={setExistingValues}
      setIsEditing={setIsEditing}
      setValues={setValues}
      modifyTrigger={modifyTrigger}
      submitting={submitting}
      type={type}
    />
  );
};

export default forwardRef(ComplexRecord);
